/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  ListPropertiesParams,
  PaginatedPropertyListOut,
  PropertyIn,
  PropertyOut,
  PropertyOwnersOut,
  PropertyStatsOut,
  SetPropertyOwnersIn
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listPropertiesResponse200 = {
  data: PaginatedPropertyListOut
  status: 200
}

export type listPropertiesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listPropertiesResponseSuccess = (listPropertiesResponse200) & {
  headers: Headers;
};
export type listPropertiesResponseError = (listPropertiesResponse422) & {
  headers: Headers;
};

export type listPropertiesResponse = (listPropertiesResponseSuccess | listPropertiesResponseError)

export const getListPropertiesUrl = (params?: ListPropertiesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties?${stringifiedParams}` : `/api/properties`
}

/**
 * @summary List Properties
 */
export const listProperties = async (params?: ListPropertiesParams, options?: Parameters<typeof apiFetch>[1]): Promise<listPropertiesResponse> => {

  return apiFetch<listPropertiesResponse>(getListPropertiesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPropertiesQueryKey = (params?: ListPropertiesParams,) => {
    return [
    `/api/properties`, ...(params ? [params] : [])
    ] as const;
    }


export const getListPropertiesQueryOptions = <TData = Awaited<ReturnType<typeof listProperties>>, TError = HTTPValidationError>(params?: ListPropertiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProperties>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPropertiesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listProperties>>> = ({ signal }) => listProperties(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listProperties>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPropertiesQueryResult = NonNullable<Awaited<ReturnType<typeof listProperties>>>
export type ListPropertiesQueryError = HTTPValidationError


export function useListProperties<TData = Awaited<ReturnType<typeof listProperties>>, TError = HTTPValidationError>(
 params: undefined |  ListPropertiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProperties>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProperties>>,
          TError,
          Awaited<ReturnType<typeof listProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProperties<TData = Awaited<ReturnType<typeof listProperties>>, TError = HTTPValidationError>(
 params?: ListPropertiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProperties>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listProperties>>,
          TError,
          Awaited<ReturnType<typeof listProperties>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListProperties<TData = Awaited<ReturnType<typeof listProperties>>, TError = HTTPValidationError>(
 params?: ListPropertiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProperties>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Properties
 */

export function useListProperties<TData = Awaited<ReturnType<typeof listProperties>>, TError = HTTPValidationError>(
 params?: ListPropertiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listProperties>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPropertiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createPropertyResponse201 = {
  data: PropertyOut
  status: 201
}

export type createPropertyResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createPropertyResponseSuccess = (createPropertyResponse201) & {
  headers: Headers;
};
export type createPropertyResponseError = (createPropertyResponse422) & {
  headers: Headers;
};

export type createPropertyResponse = (createPropertyResponseSuccess | createPropertyResponseError)

export const getCreatePropertyUrl = () => {




  return `/api/properties`
}

/**
 * @summary Create Property
 */
export const createProperty = async (propertyIn: PropertyIn, options?: Parameters<typeof apiFetch>[1]): Promise<createPropertyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createPropertyResponse>(getCreatePropertyUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(propertyIn)
  }
);}





export const getCreatePropertyMutationKey = () => ['createProperty'] as const;

export const getCreatePropertyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProperty>>, TError,CreatePropertyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createProperty>>, TError,CreatePropertyMutationVariables, TContext> => {

const mutationKey = getCreatePropertyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createProperty>>, CreatePropertyMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createProperty(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePropertyMutationResult = NonNullable<Awaited<ReturnType<typeof createProperty>>>
    export type CreatePropertyMutationBody = PropertyIn
    export type CreatePropertyMutationError = HTTPValidationError
    export type CreatePropertyMutationVariables = {data: PropertyIn}

    /**
 * @summary Create Property
 */
export const useCreateProperty = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createProperty>>, TError,CreatePropertyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createProperty>>,
        TError,
        CreatePropertyMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePropertyMutationOptions(options), queryClient);
    }
    export type getPropertyResponse200 = {
  data: PropertyOut
  status: 200
}

export type getPropertyResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getPropertyResponseSuccess = (getPropertyResponse200) & {
  headers: Headers;
};
export type getPropertyResponseError = (getPropertyResponse422) & {
  headers: Headers;
};

export type getPropertyResponse = (getPropertyResponseSuccess | getPropertyResponseError)

export const getGetPropertyUrl = (recordId: number,) => {




  return `/api/properties/${recordId}`
}

/**
 * @summary Get Property
 */
export const getProperty = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getPropertyResponse> => {

  return apiFetch<getPropertyResponse>(getGetPropertyUrl(recordId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyQueryKey = (recordId: number,) => {
    return [
    `/api/properties/${recordId}`
    ] as const;
    }


export const getGetPropertyQueryOptions = <TData = Awaited<ReturnType<typeof getProperty>>, TError = HTTPValidationError>(recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyQueryKey(recordId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProperty>>> = ({ signal }) => getProperty(recordId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: recordId !== null && recordId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyQueryResult = NonNullable<Awaited<ReturnType<typeof getProperty>>>
export type GetPropertyQueryError = HTTPValidationError


export function useGetProperty<TData = Awaited<ReturnType<typeof getProperty>>, TError = HTTPValidationError>(
 recordId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProperty>>,
          TError,
          Awaited<ReturnType<typeof getProperty>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProperty<TData = Awaited<ReturnType<typeof getProperty>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProperty>>,
          TError,
          Awaited<ReturnType<typeof getProperty>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProperty<TData = Awaited<ReturnType<typeof getProperty>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Property
 */

export function useGetProperty<TData = Awaited<ReturnType<typeof getProperty>>, TError = HTTPValidationError>(
 recordId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProperty>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyQueryOptions(recordId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type updatePropertyResponse200 = {
  data: PropertyOut
  status: 200
}

export type updatePropertyResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updatePropertyResponseSuccess = (updatePropertyResponse200) & {
  headers: Headers;
};
export type updatePropertyResponseError = (updatePropertyResponse422) & {
  headers: Headers;
};

export type updatePropertyResponse = (updatePropertyResponseSuccess | updatePropertyResponseError)

export const getUpdatePropertyUrl = (recordId: number,) => {




  return `/api/properties/${recordId}`
}

/**
 * @summary Update Property
 */
export const updateProperty = async (recordId: number,
    propertyIn: PropertyIn, options?: Parameters<typeof apiFetch>[1]): Promise<updatePropertyResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updatePropertyResponse>(getUpdatePropertyUrl(recordId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(propertyIn)
  }
);}





export const getUpdatePropertyMutationKey = () => ['updateProperty'] as const;

export const getUpdatePropertyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProperty>>, TError,UpdatePropertyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateProperty>>, TError,UpdatePropertyMutationVariables, TContext> => {

const mutationKey = getUpdatePropertyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateProperty>>, UpdatePropertyMutationVariables> = (props) => {
          const {recordId,data} = props ?? {};

          return  updateProperty(recordId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePropertyMutationResult = NonNullable<Awaited<ReturnType<typeof updateProperty>>>
    export type UpdatePropertyMutationBody = PropertyIn
    export type UpdatePropertyMutationError = HTTPValidationError
    export type UpdatePropertyMutationVariables = {recordId: number;data: PropertyIn}

    /**
 * @summary Update Property
 */
export const useUpdateProperty = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateProperty>>, TError,UpdatePropertyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateProperty>>,
        TError,
        UpdatePropertyMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePropertyMutationOptions(options), queryClient);
    }
    export type deletePropertyResponse204 = {
  data: void
  status: 204
}

export type deletePropertyResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deletePropertyResponseSuccess = (deletePropertyResponse204) & {
  headers: Headers;
};
export type deletePropertyResponseError = (deletePropertyResponse422) & {
  headers: Headers;
};

export type deletePropertyResponse = (deletePropertyResponseSuccess | deletePropertyResponseError)

export const getDeletePropertyUrl = (recordId: number,) => {




  return `/api/properties/${recordId}`
}

/**
 * @summary Delete Property
 */
export const deleteProperty = async (recordId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deletePropertyResponse> => {

  return apiFetch<deletePropertyResponse>(getDeletePropertyUrl(recordId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeletePropertyMutationKey = () => ['deleteProperty'] as const;

export const getDeletePropertyMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProperty>>, TError,DeletePropertyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteProperty>>, TError,DeletePropertyMutationVariables, TContext> => {

const mutationKey = getDeletePropertyMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteProperty>>, DeletePropertyMutationVariables> = (props) => {
          const {recordId} = props ?? {};

          return  deleteProperty(recordId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePropertyMutationResult = NonNullable<Awaited<ReturnType<typeof deleteProperty>>>

    export type DeletePropertyMutationError = HTTPValidationError
    export type DeletePropertyMutationVariables = {recordId: number}

    /**
 * @summary Delete Property
 */
export const useDeleteProperty = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteProperty>>, TError,DeletePropertyMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteProperty>>,
        TError,
        DeletePropertyMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePropertyMutationOptions(options), queryClient);
    }
    export type getPropertyStatsResponse200 = {
  data: PropertyStatsOut
  status: 200
}

export type getPropertyStatsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getPropertyStatsResponseSuccess = (getPropertyStatsResponse200) & {
  headers: Headers;
};
export type getPropertyStatsResponseError = (getPropertyStatsResponse422) & {
  headers: Headers;
};

export type getPropertyStatsResponse = (getPropertyStatsResponseSuccess | getPropertyStatsResponseError)

export const getGetPropertyStatsUrl = (propertyId: number,) => {




  return `/api/properties/${propertyId}/stats`
}

/**
 * @summary Get Property Stats
 */
export const getPropertyStats = async (propertyId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getPropertyStatsResponse> => {

  return apiFetch<getPropertyStatsResponse>(getGetPropertyStatsUrl(propertyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPropertyStatsQueryKey = (propertyId: number,) => {
    return [
    `/api/properties/${propertyId}/stats`
    ] as const;
    }


export const getGetPropertyStatsQueryOptions = <TData = Awaited<ReturnType<typeof getPropertyStats>>, TError = HTTPValidationError>(propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyStats>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPropertyStatsQueryKey(propertyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPropertyStats>>> = ({ signal }) => getPropertyStats(propertyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: propertyId !== null && propertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPropertyStats>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPropertyStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getPropertyStats>>>
export type GetPropertyStatsQueryError = HTTPValidationError


export function useGetPropertyStats<TData = Awaited<ReturnType<typeof getPropertyStats>>, TError = HTTPValidationError>(
 propertyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyStats>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyStats>>,
          TError,
          Awaited<ReturnType<typeof getPropertyStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyStats<TData = Awaited<ReturnType<typeof getPropertyStats>>, TError = HTTPValidationError>(
 propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyStats>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPropertyStats>>,
          TError,
          Awaited<ReturnType<typeof getPropertyStats>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPropertyStats<TData = Awaited<ReturnType<typeof getPropertyStats>>, TError = HTTPValidationError>(
 propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyStats>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Property Stats
 */

export function useGetPropertyStats<TData = Awaited<ReturnType<typeof getPropertyStats>>, TError = HTTPValidationError>(
 propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPropertyStats>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPropertyStatsQueryOptions(propertyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type listPropertyOwnersResponse200 = {
  data: PropertyOwnersOut
  status: 200
}

export type listPropertyOwnersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listPropertyOwnersResponseSuccess = (listPropertyOwnersResponse200) & {
  headers: Headers;
};
export type listPropertyOwnersResponseError = (listPropertyOwnersResponse422) & {
  headers: Headers;
};

export type listPropertyOwnersResponse = (listPropertyOwnersResponseSuccess | listPropertyOwnersResponseError)

export const getListPropertyOwnersUrl = (propertyId: number,) => {




  return `/api/properties/${propertyId}/owners`
}

/**
 * @summary List Property Owners
 */
export const listPropertyOwners = async (propertyId: number, options?: Parameters<typeof apiFetch>[1]): Promise<listPropertyOwnersResponse> => {

  return apiFetch<listPropertyOwnersResponse>(getListPropertyOwnersUrl(propertyId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListPropertyOwnersQueryKey = (propertyId: number,) => {
    return [
    `/api/properties/${propertyId}/owners`
    ] as const;
    }


export const getListPropertyOwnersQueryOptions = <TData = Awaited<ReturnType<typeof listPropertyOwners>>, TError = HTTPValidationError>(propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPropertyOwners>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListPropertyOwnersQueryKey(propertyId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPropertyOwners>>> = ({ signal }) => listPropertyOwners(propertyId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: propertyId !== null && propertyId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPropertyOwners>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListPropertyOwnersQueryResult = NonNullable<Awaited<ReturnType<typeof listPropertyOwners>>>
export type ListPropertyOwnersQueryError = HTTPValidationError


export function useListPropertyOwners<TData = Awaited<ReturnType<typeof listPropertyOwners>>, TError = HTTPValidationError>(
 propertyId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPropertyOwners>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPropertyOwners>>,
          TError,
          Awaited<ReturnType<typeof listPropertyOwners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPropertyOwners<TData = Awaited<ReturnType<typeof listPropertyOwners>>, TError = HTTPValidationError>(
 propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPropertyOwners>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPropertyOwners>>,
          TError,
          Awaited<ReturnType<typeof listPropertyOwners>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListPropertyOwners<TData = Awaited<ReturnType<typeof listPropertyOwners>>, TError = HTTPValidationError>(
 propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPropertyOwners>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Property Owners
 */

export function useListPropertyOwners<TData = Awaited<ReturnType<typeof listPropertyOwners>>, TError = HTTPValidationError>(
 propertyId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPropertyOwners>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPropertyOwnersQueryOptions(propertyId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setPropertyOwnersResponse200 = {
  data: PropertyOwnersOut
  status: 200
}

export type setPropertyOwnersResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setPropertyOwnersResponseSuccess = (setPropertyOwnersResponse200) & {
  headers: Headers;
};
export type setPropertyOwnersResponseError = (setPropertyOwnersResponse422) & {
  headers: Headers;
};

export type setPropertyOwnersResponse = (setPropertyOwnersResponseSuccess | setPropertyOwnersResponseError)

export const getSetPropertyOwnersUrl = (propertyId: number,) => {




  return `/api/properties/${propertyId}/owners`
}

/**
 * @summary Set Property Owners
 */
export const setPropertyOwners = async (propertyId: number,
    setPropertyOwnersIn: SetPropertyOwnersIn, options?: Parameters<typeof apiFetch>[1]): Promise<setPropertyOwnersResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setPropertyOwnersResponse>(getSetPropertyOwnersUrl(propertyId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(setPropertyOwnersIn)
  }
);}





export const getSetPropertyOwnersMutationKey = () => ['setPropertyOwners'] as const;

export const getSetPropertyOwnersMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPropertyOwners>>, TError,SetPropertyOwnersMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPropertyOwners>>, TError,SetPropertyOwnersMutationVariables, TContext> => {

const mutationKey = getSetPropertyOwnersMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPropertyOwners>>, SetPropertyOwnersMutationVariables> = (props) => {
          const {propertyId,data} = props ?? {};

          return  setPropertyOwners(propertyId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPropertyOwnersMutationResult = NonNullable<Awaited<ReturnType<typeof setPropertyOwners>>>
    export type SetPropertyOwnersMutationBody = SetPropertyOwnersIn
    export type SetPropertyOwnersMutationError = HTTPValidationError
    export type SetPropertyOwnersMutationVariables = {propertyId: number;data: SetPropertyOwnersIn}

    /**
 * @summary Set Property Owners
 */
export const useSetPropertyOwners = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPropertyOwners>>, TError,SetPropertyOwnersMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setPropertyOwners>>,
        TError,
        SetPropertyOwnersMutationVariables,
        TContext
      > => {
      return useMutation(getSetPropertyOwnersMutationOptions(options), queryClient);
    }
